var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 153.9653 190.4673",
    enableBackground: "new 0 0 153.9653 190.4673",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.5854,108.5376l-9.7227,70.1289c-0.7861,5.6738,3.1768,10.9141,8.8545,11.7012 c5.6739,0.7871,10.9141-3.1778,11.7012-8.8516l7.501-54.1035h10.1269l7.501,54.1035c0.7871,5.6738,6.0273,9.6387,11.7012,8.8516 c5.6758-0.7871,9.6406-6.0274,8.8535-11.7012l-9.7227-70.1289H53.5854z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9828,0C65.4339,0,56.0726,9.3613,56.0726,20.9102c0,11.5488,9.3613,20.9121,20.9102,20.9121 c11.5507,0,20.9101-9.3633,20.9101-20.9121C97.8929,9.3613,88.5335,0,76.9828,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6928,17.5537L54.1742,57.749v45.7886h45.6171V57.748l51.4825-40.1943c3.0468-2.3779,3.5869-6.7764,1.209-9.8252 c-2.3799-3.0473-6.7774-3.5874-9.8252-1.2095L90.8704,46.9531H63.0961L11.309,6.519C8.2592,4.1411,3.8618,4.6812,1.4829,7.7285 C-0.8961,10.7773-0.355,15.1758,2.6928,17.5537z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildIcon);
export default __webpack_public_path__ + "static/media/child-icon.a320dc84a243bb0de52a2c3e3e82cf35.svg";
export { ForwardRef as ReactComponent };